import { computed, defineComponent, ref, set, useCssModule } from '@nuxtjs/composition-api';
import { useTask } from 'vue-concurrency';
import { useDuck } from '~/services';
export default defineComponent({
    name: 'BoxRating',
    props: {
        box: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * Composables.
         */
        const css = useCssModule();
        const duck = useDuck();
        const shouldShowRating = ref(false);
        const isSport = computed(() => props.box?.data?.article?.rating?.profiletid === 'team');
        const fetchArticleTask = useTask(function* () {
            if (!props.box?.data?.id) {
                return;
            }
            const { data: rating } = yield duck.pub.getPubRatingById(props.box.data.id);
            if (!rating) {
                return console.error('[BoxRating]: There is no rating');
            }
            const { fields = [], field_values: values = {} } = rating || {};
            shouldShowRating.value = Boolean(fields?.length && values);
            const { article = {} } = rating;
            // if (!article) {
            //   return console.error('[BoxRating]: There is no article')
            // }
            set(props.box.data, 'article', {
                ...article,
                rating: {
                    ...rating,
                    isInset: true,
                },
            });
        });
        function handleArticleIntesect({ entry, observer }) {
            if (fetchArticleTask.isRunning) {
                return;
            }
            fetchArticleTask.perform();
            observer?.unobserve(entry.target);
        }
        return {
            css,
            fetchArticleTask,
            handleArticleIntesect,
            isSport,
            shouldShowRating,
        };
    },
});
